/**
 * Mixin con utilities per lo scrollToElement
 */
export default {
    methods: {
        scrollToElement(target, options = { behavior: 'smooth', block: 'start', inline: 'nearest' }, withOffset = true) {
			let element = null;
			
			// Controlla se target è una stringa (selettore CSS) o un riferimento Vue
			if (typeof target === 'string') {
				// Prima controlla se è il nome di un riferimento Vue
				if (this.$refs[target]) {
					element = this.$refs[target];
				} else {
					// Altrimenti prova come selettore CSS
					element = document.querySelector(target);
				}
			} else if (target && typeof target === 'object') {
				// Se è un riferimento Vue diretto
				element = target;
			}
			
			// Esegui lo scroll se l'elemento è stato trovato
			if (element) {
				// Calcola l'offset basato sull'altezza della sezione hero
				const heroSection = document.querySelector('#header');
				const heroHeight = heroSection ? heroSection.offsetHeight : 0;
				
				// Applica un offset aggiuntivo per compensare l'altezza dell'header
				window.scrollTo({
					top: element.offsetTop - heroHeight,
					left: 0,
					behavior: options.behavior
				});
			}
		}
    }
}